import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {AlertModal, ModalButtons} from 'shared/components/modals';
import {FormattedMessage} from 'react-intl';
import _ from 'lodash';
import {ObjectSelect2} from 'shared/components';

const UnshareRevieweeModal = observer(({reviewee, onClose, onSubmit, isOpen, options}) => {
  const [selectedReview, setSelectedReview] = useState();

  useEffect(() => {
    setSelectedReview(null);
  }, [isOpen]);

  return (
    <AlertModal
      isOpen={isOpen}
      onHide={onClose}
      size='md'
      header='performance_reviews.view.Unshare'
    >
      <div className='space-y-2'>
        <FormattedMessage
          id='performance_reviews.view.UNSHARE_REVIEWEE_DESCRIPTION'
          values={{revieweeName: _.get(reviewee, 'employee.name')}}
        />
        {options && <ObjectSelect2
          label='performance_reviews.view.Manager Review'
          display='reviewer.name'
          items={options}
          value={selectedReview}
          onChange={setSelectedReview}
        />}
      </div>
      <ModalButtons
        saveCaption='performance_reviews.view.Unshare'
        onSave={() => onSubmit(selectedReview)}
        onCancel={onClose}
      />
    </AlertModal>
  );
});

export default UnshareRevieweeModal;
